<template>
  <div class="container-fluid d-flex flex-column">
    <h4 class="d-flex mt-3">
      Fantasy Sports on Safaricom – Terms and Conditions
    </h4>

    <div class="d-flex mt-3">
      <b>IMPORTANT NOTICE</b>
    </div>
    <div class="d-flex px-2">
      A. These Terms and Conditions contain assumptions of risk and/or liability by Customers
      and limit and exclude liabilities, obligations, and legal responsibilities which Safaricom will
      have towards Customers and other persons.
    </div>
    <div class="d-flex px-2">
      B. These Terms and Conditions also limit and exclude Customers’ rights and remedies
      against Safaricom and place various risks, liabilities, obligations, and legal responsibilities
      on the Customer.
    </div>
    <div class="d-flex px-2">
      C. These Terms and Conditions may result in Customers being responsible for paying
      additional costs and amounts. Safaricom may also have claims and other rights against the
      Customer.
    </div>
    <div class="d-flex px-2">
      D. Customers must read these Terms and Conditions carefully. Use of this product/service
      constitutes agreement to comply.
    </div>
    <div class="d-flex px-2">
      E. These Terms and Conditions must be read together with the standard Safaricom Internet
      Content Pass Terms and Conditions.
    </div>

    <div class="d-flex mt-3">
      <b>1. Introduction</b>
    </div>
    <div class="d-flex px-2">
      1.1 Safaricom customers who subscribe to the Fantasy Sports (FS) service gain access to a
      mobile fantasy football platform that allows them to build a virtual team of real-life players,
      compete against other users, and participate in ongoing fantasy game events.
    </div>
    <div class="d-flex px-2">
      1.2 The Fantasy Sports service is a subscription-based service charged at:
    </div>
    <div class="d-flex px-2">- KSH 10.00 per day</div>
    <div class="d-flex px-2">- Users must subscribe at: http://ke-mplay.fantasyfootball.one</div>
    <div class="d-flex px-2">
      - Pricing may vary depending on promotional activity or adjustments by Safaricom.
    </div>

    <div class="d-flex mt-3">
      <b>2. Duration</b>
    </div>
    <div class="d-flex px-2">
      2.1 This offering is available from 1 November 2025 until such time as Safaricom elects to
      terminate it in its sole discretion.
    </div>
    <div class="d-flex px-2">
      2.2 Safaricom may amend the duration of the Offer to a shorter or longer period, or
      withdraw it entirely, with notice to customers.
    </div>
    <div class="d-flex px-2">
      2.3 Visit https://www.safaricom.co.ke/ for notices, updates, and/or changes.
    </div>

    <div class="d-flex mt-3">
      <b>3. Eligibility</b>
    </div>
    <div class="d-flex px-2">
      3.1 To participate, the Customer must:
    </div>
    <div class="d-flex px-2">- Be a Kenyan citizen</div>
    <div class="d-flex px-2">- Reside in Kenya</div>
    <div class="d-flex px-2">- Be a natural person</div>
    <div class="d-flex px-2">- Be 18 years or older or have parental consent</div>
    <div class="d-flex px-2">- Be a Safaricom subscriber</div>
    <div class="d-flex px-2">
      - Subscribe to the FS service via USSD, mobile site, or other channels made available by
      Safaricom.
    </div>

    <div class="d-flex mt-3">
      <b>4. How the Service Works</b>
    </div>
    <div class="d-flex px-2">
      - Each participant may submit a team for a fantasy event before the deadline. No changes
      may be made once an event begins.
    </div>
    <div class="d-flex px-2">
      - Points are earned based on the real-match performance of selected players.
    </div>
    <div class="d-flex px-2">
      - Total match points contribute to a participant’s overall event score. Leaderboard rankings
      are based solely on accumulated points.
    </div>
    <div class="d-flex px-2">
      - Points are awarded for standard football actions such as goals, assists, defensive actions,
      saves, and other official match statistics.
    </div>
    <div class="d-flex px-2">
      - If a selected player does not participate in a real match, that player receives zero points.
    </div>
    <div class="d-flex px-2">
      - Matches postponed or rescheduled outside the fantasy event window earn no points.
    </div>
    <div class="d-flex px-2">
      - Participants must maintain an active subscription to enter events, set line-ups, and
      accumulate points.
    </div>
    <div class="d-flex px-2">
      - The service is a skill-based fantasy game. Fantasy outcomes are based on participant
      selections and player statistics. This service does not constitute gambling.
    </div>
    <div class="d-flex px-2">
      - Safaricom may amend scoring rules or event formats with notice through the service.
    </div>

    <div class="d-flex mt-3">
      <b>5. Unsubscribing</b>
    </div>
    <div class="d-flex px-2">
      5.1 Customers may unsubscribe at any time by dialling *456*20#.
    </div>
    <div class="d-flex px-2">
      5.2 Upon unsubscribing, the user will lose access to future competitions and features tied to
      their subscription. Fanclash may retain profile records for regulatory and marketing
      purposes.
    </div>

    <div class="d-flex mt-3">
      <b>6. Personal Information</b>
    </div>
    <div class="d-flex px-2">
      (a) Definition
    </div>
    <div class="d-flex px-2">
      “Personal Information” means personally identifiable information as prescribed in the Data
      Protection Act, including but not limited to name, address, phone number, identification
      number, and location data.
    </div>
    <div class="d-flex px-2">
      (b) Collection
    </div>
    <div class="d-flex px-2">
      We are required by law to collect certain personal information and are legally obligated to
      deny you the Promotion if such information is not provided.
    </div>
    <div class="d-flex px-2">
      We may also collect personal information to ensure quality service delivery. Although
      voluntary, failure to provide such information may limit service access.
    </div>
    <div class="d-flex px-2">
      (c) Privacy
    </div>
    <div class="d-flex px-2">
      We are committed to respecting and protecting your privacy. Our privacy statement
      explains how we collect and use your information, with whom it is shared, and measures
      taken to protect it. This statement is available via the Safaricom Data Privacy Statement. If
      unable to access it online, please contact customer care.
    </div>
    <div class="d-flex px-2">
      (d) Minors
    </div>
    <div class="d-flex px-2">
      A person with parental authority may open and maintain a mobile number in their name on
      behalf of a minor. Parental authority includes birth parents, legal guardians, or others with
      demonstrable authority over the minor’s affairs.
    </div>

    <div class="d-flex mt-3">
      <b>7. Limitation of Liability</b>
    </div>
    <div class="d-flex px-2">
      7.1 Safaricom is not liable for delayed device or SIM delivery, interruptions to network
      services, or failures to suspend services upon request.
    </div>
    <div class="d-flex px-2">
      7.2 Safaricom will not be liable for loss caused by negligent acts of Safaricom, its employees,
      or agents, or due to use of devices related to this service.
    </div>
    <div class="d-flex px-2">
      7.3 This limitation does not apply where warranties are implied by law to the extent such
      limitations are disallowed.
    </div>

    <div class="d-flex mt-3">
      <b>8. General</b>
    </div>
    <div class="d-flex px-2">
      8.1 Leaderboards will be updated on the service platform and can be accessed via the FS
      portal or USSD code (as advised by Safaricom).
    </div>
    <div class="d-flex px-2">
      8.2 Safaricom and its directors, employees, agents, and affiliates assume no liability for
      direct or indirect losses, including physical harm, arising from participation.
    </div>
    <div class="d-flex px-2">
      8.3 Safaricom reserves the right to terminate subscriptions in cases of fraud or suspected
      fraud.
    </div>

    <div class="d-flex mt-3">
      <b>9. Data Retention</b>
    </div>
    <div class="d-flex px-2">
      We retain your data while your profile is active and for up to 6 months post-cancellation for
      regulatory or promotional purposes.
    </div>

    <div class="d-flex mt-3">
      <b>10. Your Rights</b>
    </div>
    <div class="d-flex px-2">
      You may request cessation of marketing messages at any time by:
    </div>
    <div class="d-flex px-2">- Writing to us</div>
    <div class="d-flex px-2">- Adjusting preferences via www.safaricom.co.ke</div>
    <div class="d-flex px-2">- Following opt-out links on marketing messages</div>
    <div class="d-flex px-2">- Contacting us directly</div>
    <div class="d-flex px-2">
      We may take up to 21 days to respond.
    </div>

    <div class="d-flex mt-3">
      <b>11. Contact</b>
    </div>
    <div class="d-flex px-2">
      For further information, visit: https://www.safaricom.co.ke
    </div>
  </div>
</template>

<script>
export default {
  name: "SafaricomTerms"
}
</script>

<style scoped>
.table-fit-screen {
  font-size: x-small !important;
}
</style>
